import vLayout from "./v-layout.vue";

export default Vue => {
  Vue.component("v-layout", vLayout);
};
